<template>
  <section class="vh-100 border bg-white p-5 d-flex justify-content-center align-items-center">

    <div class="loader text-center">
      <img height="150" src="../assets/image/loader/logoLoading.gif" alt="" />

      <PopDownloadFailModal ref="popErrorModal" />

      <h6 class="mt-3 tabContent">{{ $t("member.downloading_pop") }}</h6>

      <div ref="pdfContent" class="a4 d-none">
        <PopReceipe v-if="pdfFileData" :pdfFileData="pdfFileData" :lang="lang" />
      </div>
    </div>

  </section>
</template>

<script>
import html2pdf from "html2pdf.js";
import PopDownloadFailModal from "@/components/PopDownloadFailModal.vue";

// Load Mixins
import { methodMixin } from "@/mixins/methodMixin.js";
import { filterMixin } from "@/mixins/filterMixin.js";

import PopReceipe from "@/components/PopReceipe.vue";

export default {
  name: "MobileDownloadPop",
  mixins: [methodMixin, filterMixin],
  components: {
    PopReceipe,
    PopDownloadFailModal
  },
  data() {
    return {
      transferLog: [],
      loading: true,
      isPrinting: false,
      pdfFileData: null,
      lang: null,
      isPopDownloaded: false,
      error: false,
    };
  },
  created() {
    document.title = "EasyRemessa - Download POP";
    //this.$ga.page("/download/pop");
  },
  mounted() {
    this.downloadReceipt();
  },
  computed: {},
  validations: {},
  methods: {
    downloadReceipt: async function () {
      const language = this.$route.params.language; // (BR or EN)
      const token = this.$route.params.token;
      const transfer_reference = this.$route.params.transfer;
      this.lang = language

      await this.$store.dispatch("SetToken", token);
      await this.$store.dispatch("SetActiveLanguage", language);
      // this.lang = this.$store.getters.GetActiveLanguage;

      const postData = {
        reference_code: transfer_reference,
      };

      if (!this.isPrinting) {
        this.isPrinting = true;

        await this.backend_request("/api/data/pop", postData, "post")
          .then((response) => {
            this.pdfFileData = response.data.data;
          })
          .catch((err) => {
            console.log(err);
            this.$refs.popErrorModal.showModal();
          })
          .finally(async () => {

            if (this.pdfFileData) {
              const pdfContent = this.$refs.pdfContent.innerHTML;

              const config = {
                filename: `EasyRemessa-${transfer_reference.toUpperCase()}-${this.lang}.pdf`,
                html2canvas: { scale: 4 },
                jsPDF: { unit: "cm", format: "A4", orientation: "portrait" },
              };

              await html2pdf().from(pdfContent).set(config).save();
            }

            this.isPopDownloaded = true;
          });

          setTimeout(() => {
            if (this.isPopDownloaded) {
              window.close();
            }
          }, 20000);

      }
    },
  },
};
</script>

<style scoped lang="scss">
.a4 {
  width: 21cm;
}
</style>
